import type { Plugin } from 'vue';
import AsyncError from './AsyncError.vue';
import AsyncHandler from './AsyncHandler.vue';

export const asyncHandler: Plugin = {
  install(app) {
    app.component('AsyncHandler', AsyncHandler);
    app.component('AsyncError', AsyncError);
  },
};

export * from './useAsyncFunc';
export * from './useAsyncPage';
export * from './useAsyncTable';
export { AsyncError };
